<template>
  <TheCatcherComponent>
    <StepSwap :category :is-focused :model :price :without-left-template />
  </TheCatcherComponent>
</template>

<script setup lang="ts">
import type { Price } from '@backmarket/http-api'

import TheCatcherComponent from '~/scopes/buyback/components/TheCatcher/TheCatcherComponent.vue'
import StepSwap from '~/scopes/buyback/swap/components/StepSwap/StepSwap.vue'

defineProps<{
  isFocused: boolean
  price?: Price
  model?: string
  category?: string
  withoutLeftTemplate?: boolean
}>()
</script>
